module.exports = __webpack_public_path__ + "static/media/settings-icon.dad88fc5.png";